import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import strings from "translate/language";
import { getAge, handleDetailResponse, seo } from "utils/utils";
import { genderCheck } from "utils/constants";
import ProfileAvatar from "component/common/ProfileAvatar";
import moment from "moment";
import { getUserProfile } from "reduxStore/action/userProfileAction";
import Breadcrumb from "component/common/breadcrumb";

const ViewUserProfile = () => {
  const dispatch = useDispatch();
  const [profileDetail, setProfileDetail] = useState({});
  const loginSelector = useSelector((state) => state.login);

  const userProfileDetailSelector = useSelector(
    (state) => state?.userProfileUpdate
  );

  useEffect(() => {
    dispatch(
      getUserProfile({
        user_id: handleDetailResponse(loginSelector.response?.data)._id,
        cp_id: handleDetailResponse(loginSelector.response?.data)?.cp_id,
        role_id: handleDetailResponse(loginSelector.response?.data)?.role_id,
      })
    );
  }, [dispatch, loginSelector]);
  useEffect(() => {
    if (userProfileDetailSelector.response) {
      const { response } = userProfileDetailSelector;
      if (response.status === 200) {
        const data = handleDetailResponse(response?.data);
        let baseUrl = data?.cp_id ? data?.profile_base_url : data?.base_url;
        setProfileDetail({
          ...data,
          base_url: baseUrl,
          agent_name: data?.agent_name ? data?.agent_name : null,
          mobile: data?.primary_mobile ? data?.primary_mobile : data?.mobile,
          dateofbirth: data?.date_of_birth
            ? data?.date_of_birth
            : data?.dateofbirth,
          area: data?.location ? data?.location : data?.area,
          address: data?.location ? data?.location : data?.area,
        });
      } else {
        setProfileDetail({});
      }
    }
  }, [userProfileDetailSelector]);
  useEffect(() => {
    seo({
      title: "Profile Details",
      metaDescription: "Profile details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.profileDetails}
        url={"/dashboard"}
        parentListing={strings.dashboardProfile}
        titleactive={strings.profileDetail}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 card">
            <div className="row">
              <div className="col-md-5">
                <div className="card-header">
                  <h5>{strings.profile}</h5>
                </div>
                <label
                  htmlFor="exampleInputMobileNo"
                  className="boldText"
                ></label>
                <div className="profile-detail-avatar-wrap">
                  <ProfileAvatar
                    variant="detail"
                    baseUrl={profileDetail?.base_url}
                    profilePicture={profileDetail?.profile_picture}
                    alt={strings.notavailable}
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="card-header">
                  <h5>{strings.userDetails}</h5>
                </div>
                <div className="col-sm-12">
                  {profileDetail?.agent_name && (
                    <div className="row pl-3 pt-2 ">
                      <div className="col-sm-4">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.agent_name} :
                        </label>
                      </div>

                      <div className="col-md-8">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {profileDetail?.agent_name || strings.notavailable}
                        </label>
                      </div>
                    </div>
                  )}
                  {!profileDetail?.agent_name && (
                    <div className="row pl-3 pt-2 ">
                      <div className="col-sm-4">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.firstName} :
                        </label>
                      </div>

                      <div className="col-md-8">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {profileDetail?.firstname || strings.notavailable}
                        </label>
                      </div>
                    </div>
                  )}
                  <hr />
                  {!profileDetail?.agent_name && (
                    <div className="row pl-3">
                      <div className="col-md-4">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.lastName} :
                        </label>
                      </div>

                      <div className="col-md-8">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {profileDetail?.lastname || strings.notavailable}
                        </label>
                      </div>
                    </div>
                  )}
                  {!profileDetail?.agent_name && <hr />}
                  <div className="row pl-3">
                    <div className="col-md-4">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.createdDate} :
                      </label>
                    </div>

                    <div className="col-md-8">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {moment(profileDetail?.created_date).format(
                          "DD-MM-yyyy hh:mm a"
                        ) || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row pl-3">
                    <div className="col-md-4">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.emailAddress} :
                      </label>
                    </div>
                    <div className="col-md-8">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {profileDetail?.email || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row pl-3">
                    <div className="col-md-4">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.mobileNo} :
                      </label>
                    </div>
                    <div className="col-md-8">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {profileDetail?.mobile || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row pl-3">
                    <div className="col-md-4">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.gender} :
                      </label>
                    </div>
                    <div className="col-md-8">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {genderCheck[profileDetail?.gender] || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row pl-3">
                    <div className="col-md-4">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.age} :
                      </label>
                    </div>
                    <div className="col-md-8">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {getAge(
                          profileDetail?.dateofbirth || strings.notavailable
                        )}
                      </label>
                    </div>
                  </div>
                  <hr />
                  {/* <div className="row pl-3">
                  <div className="col-md-4">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.role} :
                    </label>
                  </div>
                  <div className="col-md-8">
                    <label
                      htmlFor="exampleInputMobileNo"
                      className="boldText"
                    >
                      {profileDetail?.role_title || strings.notavailable}
                    </label>
                  </div>
                </div> */}
                  {/* <hr /> */}
                  <div className="row pl-3 pb-3">
                    <div className="col-md-4">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.address} :
                      </label>
                    </div>
                    <div className="col-md-8">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {profileDetail?.address || strings.notavailable}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewUserProfile;
